import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    display: 'block',

    ...theme.typography.ParagraphSmallMedium,

    color: 'inherit',
});
